<script>
import {Line} from 'vue-chartjs'
import {getMonthly} from '@/services/dashboard'

const lineColor = '#63c2de'
const convertHex = (hex, opacity) => {
  hex = hex.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
}

export default {
  extends: Line,
  props: ['date', 'height'],
  methods: {
    render: function () {
      let date = this.date
      let yearMonth = date.getFullYear() + '-' + (date.getMonth() + 1)
      getMonthly(yearMonth)
        .then((response) => {
          return {
            labels: response.map(transaction => {
              return 'Day ' + new Date(transaction.date).getDate()
            }),
            prices: response.map(transaction => {
              return transaction.totalPrice
            }),
            quantities: response.map(transaction => {
              return transaction.totalQuantity
            }),
            discounts: response.map(transaction => {
              return transaction.totalDiscount
            })
          }
        })
        .then((data) => {
          if (this.$data._chart) {
            this.$data._chart.destroy()
          }
          this.renderChart({
            labels: data.labels,
            datasets: [
              {
                label: 'Sales Price',
                backgroundColor: convertHex(lineColor, 10),
                borderColor: lineColor,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: data.prices
              }
            ]
          }, {
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            scales: {
              xAxes: [{
                gridLines: {
                  drawOnChartArea: false
                }
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  maxTicksLimit: 5
                },
                gridLines: {
                  display: true
                }
              }]
            },
            elements: {
              point: {
                radius: 0,
                hitRadius: 10,
                hoverRadius: 4,
                hoverBorderWidth: 3
              }
            }
          })
        })
    }
  },
  watch: {
    date () {
      this.render()
    }
  },
  mounted () {
    this.render()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chart/MonthChart.vue